import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { dashboard, bookhalfIcon, apprenticeIcon, chatIcon } from "../constants/icons";
import { useSelector } from "react-redux";
import OffcanvasMessages from "./student-dashboard/OffcanvasMessages";
import { getNotificationCount } from "../../api/afterLogin/notification";
import { getMessageCount } from "../../api/afterLogin/setting";
import { convertUTCtoLocalTime } from "../../helpers/datetime_helper";
import { checkDisabledSp } from "../../helpers/permission_helper";

const MobileBaseNavigation = ({ triggerOffCanvas }) => {
    const location = useLocation();
    const [activeItem, setActiveItem] = useState("");
    
    const adminData = useSelector((state) => state.admin);
    const loggedInUser = useSelector((state) => state.user.user);
    const paths = useSelector((state) => state.user.paths);
    const [notificationCount, setNotificationCount] = useState();
    const [messageCount, setMessageCount] = useState(null);
    const [showApprenticeship, setShowApprenticeship]   = useState(false);

    const appProducts  = adminData.products;
    const timezone     = adminData.us_timezone;
    const ePortfolio   = appProducts && appProducts?.find((product)=> product.name == "E-portfolio");
    const userSpEnabled= adminData?.user_sp_enabled;

    // ACCESS CHECK
    const [accessMykademy, setAccessMykademy]     = useState(checkDisabledSp('mykademy', appProducts, userSpEnabled));
    const [accessEportfolio, setAccessEportfolio] = useState(checkDisabledSp('eportfolio', appProducts, userSpEnabled));

    const fetchMessageCount = async () => {
      const params = {
        host: paths.message_api_url,
        userId: loggedInUser.logged_in_user.id,
        accessToken: loggedInUser.logged_in_user.token
      }
      const response = await getMessageCount(params);
      if (response) {
        setMessageCount(response?.data?.count)
      }
    }
    
    const fetchNotificationCount = async () => {
      if (loggedInUser.is_logged_in) {
        const host = window.location.hostname
        const params = {
          host: host,
          user: loggedInUser.is_logged_in
        }
        const response = await getNotificationCount(params);
        if (response) {
          setNotificationCount(response.data.count)
        }
      }
    }
  
    useEffect(() => {
      try {
        fetchMessageCount();
        fetchNotificationCount();
      } catch (e) {
        console.error(e);
      }
    });

    useEffect(() => {
        const pathSegment = location.pathname.split("/").filter(Boolean).pop();

        // Ensure "Dashboard" is selected when on the main student-dashboard route
        if (!pathSegment || pathSegment === "student-dashboard") {
            setActiveItem("Dashboard");
        } else {
            setActiveItem(pathSegment.charAt(0).toUpperCase() + pathSegment.slice(1));
        }
    }, [location.pathname]);

    const handleMenuItemClick = (itemName) => {
        setActiveItem(itemName);
        if (triggerOffCanvas) {
            triggerOffCanvas(); // Call the off-canvas trigger function
        }
    };

    useEffect(() => {
      if(appProducts && appProducts?.length > 0) {
        appProducts?.map((product, key) => {
          const expiryDate = convertUTCtoLocalTime(product.expiry_date, timezone);
          const currDate   = new Date();
          if (product.sp_uid == 'eportfolio' && expiryDate.getTime() > currDate.getTime()) {
            setShowApprenticeship(true);
          }
        })
      }
    },[appProducts]);
    
    const goToUrlHandler = (url, event) => {
      event.preventDefault();
      window.location.href = url;
      console.log('apprentice :', window.location.href)
    }

    return (
        <div className="mobile-base-navigation">
            <ul>
                <li className={activeItem === "Dashboard" ? "active" : ""}>
                    <Link
                        to="/student-dashboard"
                        onClick={() => handleMenuItemClick("Dashboard")}
                    >
                        {dashboard} <span>Dashboard</span>
                    </Link>
                </li>
                {!accessMykademy && 
                <li className={activeItem === "Courses" ? "active" : ""}>
                    <Link
                        to="/student-dashboard/courses"
                        onClick={() => handleMenuItemClick("Courses")}
                    >
                        {bookhalfIcon} <span>Courses</span>
                    </Link>
                </li>
                }
                {(showApprenticeship === true) && !accessEportfolio &&
                <li className={activeItem === "Apprentice" ? "active" : ""}>
                    <Link
                        to="/student-dashboard/apprentice"
                        onClick={goToUrlHandler.bind(true, `${ePortfolio?.url}learner/program`)}
                    >
                        {apprenticeIcon} <span>Programs</span>
                    </Link>
                </li>
                }
                <li className={activeItem === "Chat" ? "active nonlink-item" : "nonlink-item"}>
                    <OffcanvasMessages
                    triggerTitle={chatIcon}
                    triggerSubTitle={'Chat'}
                    messageCount={messageCount}
                    setMessageCount={setMessageCount}
                    />
                </li>
            </ul>
        </div>
    );
}

export default MobileBaseNavigation;
